import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

export function Card({ header, footer, children, className, ...rest }: CardProps) {
  return (
    <section className={['hsc-card', className].filter(Boolean).join(' ')} {...rest}>
      {header && <header className="hsc-card__header">{header}</header>}
      <div className="hsc-card__body">{children}</div>
      {footer && <footer className="hsc-card__footer">{footer}</footer>}
    </section>
  );
}
